var app = app || {};
(function () {

    app.localStorage = app.localStorage || {};

    app.localStorage.setItem = function (key, value) {
        return new Promise((resolve, reject) => {
            if (!window.localforage) {
                reject();
            }

            resolve(window.localforage.setItem(key, value));
        });
    };

    app.localStorage.getItem = function (key) {
        return new Promise((resolve, reject) => {
            if (!window.localforage) {
                reject();
            }

            resolve(window.localforage.getItem(key));
        });
    };

})();
